import React from 'react'
import { IIconProps } from '../types/types'

const EngagementRate: React.FC<IIconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
      height={props.width ? props.width : '16'}
      width={props.width ? props.width : '16'}
      viewBox="0 0 24 24"
    >
      <rect fill="none" height="24" width="24" />
      <path
        fill="var(--customMainColor)" 
        d="M10 20h4V4h-4zm-6 0h4v-8H4zM16 9v11h4V9z"
      />
    </svg>
  )
}

export default EngagementRate
